import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ModalController, NavController, NavParams } from 'ionic-angular';
import * as moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { AdvancedAnalyticsServices } from '../../advanced-analytics-services';
import { SelectBetweenDatetime } from '../../../components/popups/select-between-datetime/select-between-datetime';

/**
 * Generated class for the AnalyticsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-reservations-top-customers',
  templateUrl: 'reservations-top-customers.html',
})
export class ReservationsTopCustomersPage {

  public chartData: any;
  public chartLabels: any;
  public chartCheck: any;
  result: any;
  //datatable
  rows = [];
  temp = [];
  columns = [
    { prop: 'CUSTOMER', name: this.translate.instant('general-cliente') },
    { prop: 'RESERVATIONS', name: this.translate.instant('general-n-reservas') },
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public http: HttpClient,
    public advancedAnalyticsServices: AdvancedAnalyticsServices,
    public modalCtrl: ModalController
  ) {
    this.getAnalyticsData();
  }

  //funcion que abre el modal para seleccionar fechas
  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('analytics-titulo-fechas'),
      date_first: this.advancedAnalyticsServices.date1,
      date_last: this.advancedAnalyticsServices.date2,
      cash_bool: false,
    });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.advancedAnalyticsServices.date1 = data.date_first;
        this.advancedAnalyticsServices.date2 = data.date_last;
        //
        this.getAnalyticsData();
      }
    });
    profileModal.present();
  }

  async getAnalyticsData() {

    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'));

    this.chartCheck = false;//boolean check
    this.http.post(this.globals.analytics_path + 'analytics/reservations_top_customers', params, {})
      .subscribe(async response => {
        //chart
        this.chartData = response['data_reservations']['data']; //total'
        this.chartLabels = response['data_reservations']['labels'];//Dates
        //list
        this.rows = response['list'];
        this.temp = response['list'];
        //
        this.chartCheck = true;//boolean check
      });

  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.temp.filter(function (d) {
      return d.date.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  export() {
    const formatedData = this.rows.map(x => ({
      'Customer': x.CUSTOMER,
      'Nº Reservations': x.RESERVATIONS,
    }));
    const params = new HttpParams()
      .set('data', JSON.stringify(formatedData))
      .set('date1', moment(this.advancedAnalyticsServices.date1).format('DD/MM/YYYY HH:mm:ss'))
      .set('date2', moment(this.advancedAnalyticsServices.date2).format('DD/MM/YYYY HH:mm:ss'))
      .set('extras', JSON.stringify({}));
    this.http.post(this.globals.analytics_path + 'export/analytics', params, {})
      .subscribe(async res => {
        if (this.globals.so_mobile) {
          window.location.assign(res['task']);
        } else {
          window.open(res['task'], '_blank');
        }
      });
  }

}


// WEBPACK FOOTER //
// ./src/pages/analytics/reports/reservations-top-customers/reservations-top-customers.ts